import React from "react";

const UISwitch = (props) => {
  let content = (
    <label className="UI-switch">
      <input
        type="checkbox"
        id={props.idTag}
        onChange={props.onChange}
        checked={props.checked}
      />
      <span className="UI-slider"></span>
      <span className="UI-switch-tag">{props.blurb}</span>
    </label>
  );

  return content;
};

// memo acts like shouldComponentUpdate ... can use without the function, or with a function that returns false if it SHOULD rerender
export default React.memo(UISwitch, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
